import React, { Fragment } from "react";
import {
    UserAccess,
    UserHasAccess,
} from "components/user-access";
import { PageRestricted } from "pages/errors/page-restricted";
import { Breadcrumbs, HorizontalLinkGroup } from "components/navigation";
import { Route, Routes, Navigate } from "react-router-dom";
import { LicenceCheckingOverview } from "pages/licence-checking/overview";
import { LicenceCheckingDriverOnboarding } from "pages/licence-checking/driver-onboarding";
import { LicenceCheckingPolicies } from "pages/licence-checking/policies/listing";
import { LicenceCheckingCompletedChecks } from "pages/licence-checking/completed-checks";
import { LinkButton } from "components/buttons";
import { CreditCount } from "pages/licence-checking/shared/credit-count/CreditCount";
import PropTypes from "prop-types";
import { NotificationInline } from "components/notifications/NotificationInline";
import { useSelector } from "react-redux";

export function LicenceChecking({
    breadcrumbs = []
}) {
    const licenceCheckingView = "LicenceChecking:View";
    const licenceCheckingManage = "LicenceChecking:Manage";
    const greyFleet = "LicenceChecking:GreyFleet";
    
    const routes = [
        { location: "/licence-checking/overview", title: "Overview" },
        {
            location: "/licence-checking/employee-onboarding",
            title: "Employee Onboarding",
        },
        {
            location: "/licence-checking/enrolled-employees",
            title: "Enrolled Employees",
        },
    ];
    const licenceCredits = useSelector(
        (state) => state.licenceChecking.licenceCredits
    );

    if (UserHasAccess(licenceCheckingManage)) {
        routes.push({
            location: "/licence-checking/policies",
            title: "Policies",
        });
    }

    return (
        <UserAccess
            perform={licenceCheckingView}
            yes={() => (
                <Fragment>
                    <div className="row">
                        <Breadcrumbs items={breadcrumbs} />
                        <h1>Licence Checking Hub</h1>

                        <NotificationInline
                            text="You have run out of credits, until you have added more credits some data may be out of date and not processed. Please add more credits to resume functionality."
                            intent="warning"
                            show={licenceCredits <= 0}
                        />

                        <div className="button-row button-row-stacked-mobile spacer-bottom">
                            <div className="inline-items inline-items-space-reverse space-large spacer-bottom-large">
                                <CreditCount />
                                <div>
                                    <UserAccess
                                        perform={licenceCheckingManage}
                                        yes={() => (
                                            <LinkButton
                                                text="manage licence checking"
                                                intent="primary"
                                                href="/licence-checking/settings"
                                            />
                                        )}
                                    />
                                    <UserAccess
                                        perform={greyFleet}
                                        yes={() => (
                                            <LinkButton
                                                text="grey fleet hub"
                                                intent="primary"
                                                href="/licence-checking/grey-fleet"
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="spacer-bottom">
                            <HorizontalLinkGroup
                                links={routes}
                                exactRouteMatch={false}
                            ></HorizontalLinkGroup>
                        </div>

                        <Routes>
                            <Route path="overview" element={<LicenceCheckingOverview />} />
                            <Route path="employee-onboarding" element={<LicenceCheckingDriverOnboarding />} />
                            <Route path="enrolled-employees" element={<LicenceCheckingCompletedChecks />} />
                            <Route path="policies" element={<LicenceCheckingPolicies />} />
                            <Route path="" element={<Navigate to="/licence-checking/overview" replace />} />
                        </Routes>
                    </div>
                </Fragment>
            )}
            no={() => <PageRestricted />}
        />
    );
}

LicenceChecking.propTypes = {
    breadcrumbs: PropTypes.array,
};
